import "./PersonCardsBlock.scss";
import {
  DirectorsInfoCardBlock,
  OptimizelyEditProperty,
} from "/App.Components";
import { PersonCardsBlockProps } from "/Models/Generated/PersonCardsBlockProps";
import { createSpreadableBem } from "/Helpers/createBem";

const PersonCardsBlock = ({
  heading,
  headingPropertyName,
  compactStaffList,
  staffHeading,
  personCards,
  personCardsPropertyName,
}: PersonCardsBlockProps) => {
  const bem = createSpreadableBem("person-cards-block");
  const hasCards = (personCards?.length ?? 0) > 0;
  const isCompactStaffCard = (personCard: PersonCardsBlockProps["personCards"][number]) =>
    compactStaffList && !personCard.isLeader;
  const fullCards = personCards
    ?.filter((personCard) => !isCompactStaffCard(personCard))
    .sort((first, second) => Number(second.isLeader) - Number(first.isLeader));
  const staffCards = personCards?.filter(isCompactStaffCard);

  return (
    <section {...bem("")}>
      {(heading || headingPropertyName) && (
        <OptimizelyEditProperty propertyName={headingPropertyName}>
          <h2 {...bem("__heading")}>{heading}</h2>
        </OptimizelyEditProperty>
      )}

      <OptimizelyEditProperty
        propertyName={personCardsPropertyName}
        clientRender
      >
        {hasCards && (
          <div {...bem("__cards")}>
            {fullCards?.map((personCard, idx) => (
              <DirectorsInfoCardBlock
                {...personCard}
                key={idx}
              />
            ))}
            {(staffCards?.length ?? 0) > 0 && (
              <div {...bem("__staff-panel")}>
                <div {...bem("__separator")} />
                {staffHeading && (
                  <h3 {...bem("__staff-heading")}>{staffHeading}</h3>
                )}
                <div {...bem("__staff-list")}>
                  {staffCards?.map((personCard, idx) => (
                    <div key={idx} {...bem("__staff-item")}>
                      <span {...bem("__staff-name")}>{personCard.name}</span>
                      <span {...bem("__staff-title")}>{personCard.title}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </OptimizelyEditProperty>
    </section>
  );
};

export default PersonCardsBlock;
